<div style="width: 100%;">

    <div class="p-16" fxLayoutAlign="center center" >
      <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto" *ngIf="!banderaSelect">

          <mat-form-field appearance="outline" fxFlex="50" class="pr-4">
              <mat-label>{{'CERTIFICAR.DEMOGRAFICOS.SELECT' | translate}}</mat-label>
              <mat-select #selectBandera>
                 <mat-option  [value]="0">
                          {{'CERTIFICAR.DEMOGRAFICOS.OPTION_SURVEY' | translate}}
                  </mat-option>
                  <mat-option [value]="1">
                           {{'CERTIFICAR.DEMOGRAFICOS.OPTION_EXCEL' | translate}}
                   </mat-option>
              </mat-select>
              <mat-error></mat-error>
          </mat-form-field>

          <div appearance="outline" fxFlex="50" class="pr-4">
                <button mat-raised-button color="accent" style="width: 60%;"
                  (click)="setBanderaDemograficos(selectBandera.value);">{{'CERTIFICAR.DEMOGRAFICOS.BTN_DEMOGRAFICOS' | translate}}</button>
          </div>



      </div>
    </div>

    <div fxLayoutAlign="center center" style="width: 100%;">

      <div class="p-20" style="width: 100%;">

          <div cdkDropList (cdkDropListDropped)="drop($event)">

               <ng-container *ngFor="let pregunta of preguntas; let i = index; let last = last; let first = first;">
                  <div cdkDrag>
                      <mat-icon aria-hidden="false" class="mr-20" matTooltip="" style="display:none" cdkDragHandle>menu</mat-icon>

                      <mat-expansion-panel class="mb-20">
                          <mat-expansion-panel-header class="accent-100" >
                              <mat-panel-title>
                                  {{ pregunta.clave }}
                              </mat-panel-title>
                              <mat-panel-description>
                                  {{'CERTIFICAR.DEMOGRAFICOS.CONFIGURE_QUESTION' | translate}}
                              </mat-panel-description>
                          </mat-expansion-panel-header>

                          <p>{{'CERTIFICAR.DEMOGRAFICOS.QUESTION' | translate}}</p>
                          <div fxLayout="row" fxLayoutAlign="center" class="mt-20">

                              <mat-form-field class="input" appearance="outline" fxFlex="50">
                                  <mat-label>{{'CERTIFICAR.DEMOGRAFICOS.QUESTION' | translate}}</mat-label>
                                  <textarea matInput required [value]="pregunta.preguntaDemografico" (blur)="onBlurPregunta($event,pregunta);"></textarea>
                                  <mat-error>Error, complete la pregunta</mat-error>
                              </mat-form-field>
                          </div>
                          <p>{{'CERTIFICAR.DEMOGRAFICOS.OPCIONES_RESPUESTA' | translate}}</p>
                          <div fxLayout="row" fxLayoutAlign="center" >
                              <div cdkDropList (cdkDropListDropped)="drop($event)" fxLayout="column" style="width: 100%;">

                                   <div *ngFor="let opcion of pregunta.opciones; index as i;" class="opcionResp" cdkDrag >
                                      <div class="example-custom-placeholder" *cdkDragPlaceholder></div>
      <!--
                                      <mat-icon aria-hidden="false" class="mr-20" matTooltip="{{'CERTIFICAR.ADICIONALES.PREGUNTAS.WIZARD.MULTI.TOOLTIP.MOVE' | translate}}" cdkDragHandle>menu</mat-icon>
      -->
                                      <mat-form-field class="input" appearance="outline">
                                          <mat-label>{{'CERTIFICAR.DEMOGRAFICOS.OPCIONES_RESPUESTA' | translate}}</mat-label>
                                          <textarea matInput required [value]="opcion.textoOpcion" (blur)="onBlurRespuesta($event,opcion,pregunta._id);"></textarea>
                                          <mat-error>Error, complete la opcion de respuesta</mat-error>
                                      </mat-form-field>
                                  </div>

                              </div>
                          </div>

                          <div>

                          </div>

                      </mat-expansion-panel>

                  </div>
              </ng-container>

          </div>
          <!------------------------>

          <hr>


      </div>
    </div>


</div>
